function urlProvider(contentType, locale, slug) {
  if (!locale) return slug;

  const pageHierarchy = require(`../../data/${locale}/url.json`);
  if (slug && pageHierarchy[contentType] && pageHierarchy[contentType][slug]) {
    return pageHierarchy[contentType][slug];
  } else if (pageHierarchy[contentType]) {
    return pageHierarchy[contentType];
  }
  return null;
}

module.exports = urlProvider;
